<template>
  <div
    class="trial-timeline-with-reminder-step"
    v-if="plan && plan.trialDays">
    <timeline :steps="steps" />
  </div>
</template>

<script>
import Timeline from "@/shared/timeline";

export default {
  name: "TrialTimeline",
  components: {
    Timeline
  },
  props: {
    plan: {
      type: Object,
      default: null,
      validator: function (plan) {
        return plan && typeof plan.trialDays === "number" &&
          typeof plan.type === "string";
      }
    }
  },
  data() {
    return {
      trialStartDate: new Date()
    };
  },
  computed: {
    trialReminderDate() {
      const reminderDayNumber = this.plan.trialDays - 2;

      return this.$t("reminderDay", { dayNumber: reminderDayNumber });
    },
    trialEndDate() {
      const trialEndDayNumber = this.plan.trialDays;

      return this.$t("trialEndingDay", { dayNumber: trialEndDayNumber });
    },
    trialStartCopy() {
      let trialLength;

      if (this.plan.trialDays % 31 === 0) {
        trialLength = this.$tc("monthsCount", this.plan.trialDays / 31);
      } else {
        trialLength = this.$tc("daysCount", this.plan.trialDays);
      }

      return this.$t("trialStart", { trialLength });
    },
    steps() {
      const startStep = {
        label: this.$t("today"),
        text: this.trialStartCopy
      };

      const reminderStep = {
        label: this.trialReminderDate,
        text: this.$t("trialReminderCopy"),
        modifiers: ["reminder"]
      };

      const trialEndStep = {
        label: this.trialEndDate,
        text: this.$t("trialEnd")
      };

      if (this.plan.trialDays > 2) {
        return [startStep, reminderStep, trialEndStep];
      } else {
        return [startStep, trialEndStep];
      }
    }
  },
  i18n: {
    messages: {
      en: {
        reminderDay: "Day {dayNumber}",
        trialEndingDay: "Day {dayNumber}",
        daysCount: " | one day | {count} days",
        monthsCount: " | one month | {count} months",
        trialStart: "Start enjoying the entire library of Blinks and shows.",
        trialEnd: "Free trial ends.",
        today: "Today",
        trialReminderCopy: "We’ll send you a <strong>reminder</strong> email that your trial is ending.",
        arrowMessage: {
          monthly: "Continue learning <br>with Blinkist!",
          yearly: "Continue learning <br>with Blinkist!"
        }
      },
      de: {
        reminderDay: "Tag {dayNumber}",
        trialEndingDay: "Tag {dayNumber}",
        daysCount: " | 1 Tag | {count} Tage",
        monthsCount: " | 1 Monat | {count} Monate",
        trialStart: "Du hast jetzt {trialLength} kostenlos Zugang zu allen Titeln.",
        trialEnd: "Ende des Probeabos",
        today: "Heute",
        trialReminderCopy: "Wir senden dir eine <strong>Erinnerungs-E-Mail</strong>, dass deine Testversion endet.",
        arrowMessage: {
          monthly: "Dein Monatsabo <br>beginnt.",
          yearly: "Dein Jahresabo <br>beginnt."
        }
      }
    }
  }
};
</script>

<style lang="scss">
.trial-timeline-with-reminder-step {
  $root: &;
  $margin-bottom-date: $spacing-24;
  $margin-top-bullet: $spacing-4;
  $size-bullet: $spacing-16;

  margin-bottom: $spacing-24;

  background-color: $white;

  @include media(min-width, m) {
    margin-bottom: $spacing-48;
    padding: 0;
  }
}
</style>
